//import $ from 'jquery';
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer,SuperClusterAlgorithm,DefaultRenderer } from "@googlemaps/markerclusterer";
import { tns } from 'tiny-slider/src/tiny-slider';

let map;
let bounds = null;
let clusters = null;
let $dataPanel = null;
const mapElement = document.getElementsByClassName('carte-layout__map');
const searchInput = document.getElementsByClassName('js-map-search');
const categSelects = document.getElementsByClassName('js-choose-categ');
const mapVenueCatds = document.getElementsByClassName('map-venue-card');
let markerMode = 'basic';
let infowindow = null;
let infowindowTimeout = null;

if(mapElement){
    Array.prototype.forEach.call(mapElement, creationGMapElement)
}

function creationGMapElement(el){
    const lat = 46;
    const lng = -73;
    const lang = el.getAttribute('data-lang');
    const key = el.getAttribute('data-key');
    let loader;
    try {
        loader = new Loader({
            apiKey:key,
            version:'weekly',
            language: lang.substring(0,2),
            //version:'beta',
            //libraries: ["marker"]
        });
    } catch (error) {
        location.reload();
    }
    loader.load().then(()=>{
        var reclat = 0.0004;
        var reclng = 0.000;
        map = new google.maps.Map(document.getElementById(el.getAttribute('id')), {
            center: {lat: lat+reclat, lng: lng+reclng},
            zoom: 10,
            language: lang,
            streetViewControl:false,
            mapTypeControl: false,
            styles: actMapStyles
        });
        map.addListener('mapcapabilities_changed', () => {
            const mapCapabilities = map.getMapCapabilities();
          
            if (!mapCapabilities.isAdvancedMarkersAvailable) {
                markerMode = 'basic';
            } else {
                markerMode = 'advanced';
            }
          });
          
        infowindow = new google.maps.InfoWindow({
            content: '',
        }); 
       
        google.maps.event.addListener(infowindow, 'domready', function() {
            document.querySelector('.infowindow').addEventListener('mouseover', function(e) {
                if (!e.currentTarget.classList.contains('infowindow--active')) {
                    clearTimeout(infowindowTimeout);
                }
            });
            document.querySelector('.infowindow').addEventListener('mouseout', function(e) {
                if (!e.currentTarget.classList.contains('infowindow--active')) {
                    infowindowTimeout = setTimeout(closeInfoWindow, 250);
                }
            });
            document.querySelector('.infowindow .js-close-data-panel').addEventListener('click',closePin);
        });
          redoMarkers();
    })
}

function closeInfoWindow() {
    infowindow.close();
    infowindow.setContent(infowindow.getContent().replace("infowindow--active", ""));
}

/*
if(categSelects){
    Array.prototype.forEach.call(categSelects,function(el){
        el.addEventListener('change',function(){
            console.log('redraw - categs');
            redoMarkers();
        })
    })
} 
// Le On marche pas, https://github.com/sa-si-dev/virtual-select/issues/194 Passé aux développeurs du truc
// C'est une fonctionalité écrite dans leur doc, alors j'imagine c'est juste un glitch, qui sera réglé.
// Désolé du funk en dessous, mais c'est fait que on puisse continuer a travailler, et on mettera le onchange quand sa sera réglé.
// https://sa-si-dev.github.io/virtual-select/#/events
*/
setInterval(triggerCheckRedoMarkersByCategorySelect,100)
function triggerCheckRedoMarkersByCategorySelect(){
    var triggerRewrite = false;
    if(categSelects){
        Array.prototype.forEach.call(categSelects,function(el){
            //console.log(String(el.value))
            if(!el.hasAttribute('currentValue') && el.value){
                el.setAttribute('currentValue',el.value);
            }else if(el.getAttribute('currentValue') != String(el.value)){
                el.setAttribute('currentValue',el.value);
                triggerRewrite = true;
            }
        })
    }
    if(triggerRewrite){
        redoMarkers();
    }
}
setInterval(keepPinsTabbable,500)
function keepPinsTabbable(){
    const pins = document.querySelectorAll('.carte-layout__map [role="button"]')
    if(pins.length != 0){
        pins.forEach(function(e){
            e.setAttribute('tabindex',0);
        })
    }
}

if(searchInput){
    searchInput[0].addEventListener('keyup',triggerRedoMarkersByTextSearch)
}
var timeout;
function triggerRedoMarkersByTextSearch(){
    clearTimeout(timeout);
    //console.log('search');
    if(searchInput[0].value){
        document.getElementsByTagName('body')[0].classList.add('map-venue-cards-open');
        searchInput[0].parentElement.classList.add('map-text-search__has-data');
    }else{
        searchInput[0].parentElement.classList.remove('map-text-search__has-data');
    }
    timeout = setTimeout(redoMarkers, 500);
}

const ClusterRenderer = function() {
    const svg = window.btoa(clusterSVG);
    return {
        render: ({ count, position }) => {

           return new google.maps.Marker({
               title: String(count)+' '+clusterText, 
                label: { 
                    text: String(count), 
                    color: clusterNumberColor, 
                    fontSize: clusterNumberFontSize,
                    fontWeight: clusterNumberFontWeight,
                    fontFamily: clusterNumberFontFamily
                },
                icon: {
                    url: `data:image/svg+xml;base64,${svg}`,
                    scaledSize: new google.maps.Size(clusterSize, clusterSize)
                },
                position,
                // adjust zIndex to be above other markers
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                optimized: false
            })
        }
    }
}
/*
function buildMarkerMarkup(data)
{
    const content = document.createElement("div");

  content.classList.add("pin");
  content.innerHTML = `
    <div class="icon">
        <?xml version="1.0" encoding="UTF-8"?>
        <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512"><path d="M19,1H5A5.006,5.006,0,0,0,0,6V18a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V6A5.006,5.006,0,0,0,19,1ZM5,3H19a3,3,0,0,1,2.78,1.887l-7.658,7.659a3.007,3.007,0,0,1-4.244,0L2.22,4.887A3,3,0,0,1,5,3ZM19,21H5a3,3,0,0,1-3-3V7.5L8.464,13.96a5.007,5.007,0,0,0,7.072,0L22,7.5V18A3,3,0,0,1,19,21Z"/></svg>
    </div>
    `;
    //TODO addinfowindow
  return content;

}
*/
function adjustMarkerVisibility()
{
    if(actMapData.length){
        actMapData.forEach(function(e){

            if (e.marker.getMap()) {
                if (!e.htmlMarker.getMap()) {
                    e.htmlMarker.setMap(map);
                }
            } else {
                if (e.htmlMarker.getMap()) {
                    e.htmlMarker.setMap(null);
                }
            }
        });
    }

}

function generateInfoWindowContent(e) {

    const categArray = e.categ.split('|');
    let categString = '';
    Array.prototype.forEach.call(categArray,function(c){
        //console.log(c);
        if(c != ''){
            categString += '<div class="map-badge">'+c+'</div>';
        }
    })
    const closeButton = document.querySelector('.js-close-data-panel').cloneNode(true);
    var wrap = document.createElement('div');
    wrap.appendChild(closeButton);
    closeButton.classList.add('infowindow__close');
    closeButton.classList.add('icon-button--small');
    const infowindowContent = '<div class="infowindow">'+wrap.innerHTML+'<div class="infowindow__categ map-badges">'+categString+'</div><div class="infowindow__title">'+e.title+'</div></div>'
    return infowindowContent;
}


function redoMarkers(){
    class HtmlMarker extends google.maps.OverlayView {
        position;
        icon;
        color;
        title;
        div;
        constructor(position, icon, title, color) {
          super();
          this.position = position;
          this.icon = icon;
          this.title = title;
          this.color = color;
        }
        /**
         * onAdd is called when the map's panes are ready and the overlay has been
         * added to the map.
         */
        onAdd() {
            const panes = this.getPanes();
            this.div = document.createElement("div");
            this.div.style.borderStyle = "none";
            this.div.style.borderWidth = "0px";
            this.div.style.position = "absolute";
            this.div.classList.add('carte-pin');
            this.div.innerHTML = pinSVG+(this.icon ? this.icon : '');
            this.div.childNodes[0].classList.add('carte-pin__marker');
            const paths = this.div.childNodes[0].getElementsByTagName('path');
            for (var i = 0; i < paths.length; i++) {
                paths[i].style.fill = this.color;
            }
            if (this.div.childNodes.length > 1) {
                this.div.childNodes.item(1).classList.add('carte-pin__icon');
            }
            panes.overlayLayer.appendChild(this.div)
        }
        draw() {
            const projection = this.getProjection()
            const point = projection.fromLatLngToDivPixel(this.position)
            if (point === null) {
              return
            }
            this.div.style.transform = `translate(${point.x}px, ${point.y}px)`
        }
        /**
         * The onRemove() method will be called automatically from the API if
         * we ever set the overlay's map property to 'null'.
         */
        onRemove() {
          if (this.div) {
            this.div.parentNode.removeChild(this.div);
            delete this.div;
          }
        }
        /**
         *  Set the visibility to 'hidden' or 'visible'.
         */
        hide() {
          if (this.div) {
            this.div.style.visibility = "hidden";
          }
        }
        show() {
          if (this.div) {
            this.div.style.visibility = "visible";
          }
        }
        toggle() {
          if (this.div) {
            if (this.div.style.visibility === "hidden") {
              this.show();
            } else {
              this.hide();
            }
          }
        }
        toggleDOM(map) {
          if (this.getMap()) {
            this.setMap(null);
          } else {
            this.setMap(map);
          }
        }
      }

    //console.log('redraw');
    let fitBounds = false;
    bounds = new google.maps.LatLngBounds();
    
    if (!clusters) {
        clusters = new MarkerClusterer({
            map:map,
            renderer:new ClusterRenderer, 
            algorithm: new SuperClusterAlgorithm({
                radius:clusterRadius
            }),
            onClusterClick: (
                _,
                cluster,
                map
              ) => {
                  closePin(false);
                map.fitBounds(cluster.bounds);
              }
        });
        
        google.maps.event.addListener(
            clusters,
            'clusteringend',
            adjustMarkerVisibility
          );
    }
    //True est important pour ne pas reconstruire la carte tout de suite, on fait render plus bas
    clusters.clearMarkers(true);
    //console.log(bounds);
    if(actMapData.length){
        const additionnalCateg  = document.getElementsByTagName('body')[0].getAttribute('data-additionnal-categ');
        actMapData.forEach(function(e){
            /*
                En gros a chaque update de la map (on resize ou recherche text/categ) on repasse la fonction qui fait les pins.
                On commence par un add = true, et on passe au travers des possibilités qui pourraient demander leur retrait.
            */
            let addThisElement = true;
            // Check les catégories
            if(categSelects){
                Array.prototype.forEach.call(categSelects,function(el){
                    // Petite optimisation. Si addThisElement est déja false, 
                    // ce qui veut dire ne sera pas redraw,
                    // skipper le check.
                    if(el.value.length > 0 && addThisElement){
                        let needRemoval = true;
                        Array.prototype.forEach.call(el.value,function(categ){
                            //console.log(e.categslugs + ' ' + categ);
                            if(e.categslugs.includes(categ)){
                                needRemoval = false;
                            }
                        });
                        if(needRemoval){
                            addThisElement = false;
                        }
                    };
                })
            }
            //Check les catégories additionnelles
            if(additionnalCateg && addThisElement){
                if(!e.categslugs.includes(additionnalCateg)){
                    addThisElement = false;
                }
            }
            
            // Check la recherche textuelle.
            let searchText = '';
            if(searchInput[0].value && addThisElement){
                searchText = searchInput[0].value
                //console.log('---')
                //console.log(e.title + ' --- '+ searchInput[0].value);
                if(!e.title.toLowerCase().includes(searchText.toLowerCase()) && !e.categ.toLowerCase().includes(searchText.toLowerCase())){
                    //console.log('skipped')
                    addThisElement = false;
                }
            }
            if (!e.venueCard) {
                e.venueCard = document.getElementById('venue-card-'+e.id);
                //console.log(e.id+' show');
                if(e.venueCard){
                    e.venueCard.classList.remove('map-venue-card__hidden');
                    let title = e.venueCard.getElementsByClassName('map-venue-card__name');
                    let re = new RegExp(`()(${searchText})()`,'ig');
                    let badges = e.venueCard.getElementsByClassName('map-badge');
                    Array.prototype.forEach.call(badges,function(b){
                        b.innerHTML = b.getAttribute('data-badge-text').replace(re, `$1<strong>$2</strong>$3`);
                    })
                    title[0].innerHTML = e.venueCard.getAttribute('data-title').replace(re, `$1<strong>$2</strong>$3`);
                }
            }
            if(!e.marker){
                const pincolor = e.pincolor ? e.pincolor : "#000";
                //var pinpath = e.pinpath ? e.pinpath : "M34.1422 33.5876L34.1339 33.5957L21.4026 46.1202C20.6243 46.8859 19.3757 46.8859 18.5974 46.1202L5.86615 33.5957L5.85784 33.5876C-1.95261 25.904 -1.95261 13.4463 5.85784 5.76273C13.6684 -1.92091 26.3316 -1.92091 34.1422 5.76273C41.9526 13.4463 41.9526 25.904 34.1422 33.5876ZM23.5357 16.197C25.4883 18.118 25.4883 21.2323 23.5357 23.1533C21.583 25.0742 18.4172 25.0742 16.4646 23.1533C14.512 21.2323 14.512 18.118 16.4646 16.197C18.4172 14.2761 21.583 14.2761 23.5357 16.197Z"

                const pinwidth = e.pinwidth ? e.pinwidth : 45;
                const pinheight = e.pinheight ? e.pinheight : 45;
                const pinanchorx = e.pinanchorx ? e.pinanchorx : 22;
                const pinanchory = e.pinanchory ? e.pinanchory : 45;

                let marker = null;
                let htmlMarker = null;
                if (false && markerMode == 'advanced') {
                    /**
                     * new beta version marker, 
                     * https://developers.google.com/maps/documentation/javascript/advanced-markers/start
                    marker = new google.maps.marker.AdvancedMarkerView({
                        map,
                        content: buildMarkerMarkup(e),
                        position: { lat: e.lat, lng: e.lng},
                        title: e.title,
                      });
                      */
                  
                } else {
                    
                    marker = new google.maps.Marker({
                        position:{ lat: parseFloat(e.lat), lng: parseFloat(e.lng)},
                        title:e.title,
                        icon: {
                            url: `data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==`,
                            //path:pinpath,
                            scaledSize: new google.maps.Size(pinwidth, pinheight),
                            anchor: new google.maps.Point(pinanchorx,pinanchory),
                        },
                        id:e.id,
                        optimized: false
                    });
                    //console.log(e.icon);
                    htmlMarker = new HtmlMarker({ lat: parseFloat(e.lat), lng: parseFloat(e.lng)}, e.icon ? e.icon : iconDefault, e.title, e.color);
                    e.htmlMarker = htmlMarker;
                    //htmlMarker.setMap(map);
                    //Add custom overlay
                }
                const infowindowContent = generateInfoWindowContent(e);
                marker.addListener('focus',()=>{
                    closeInfoWindow();
                    infowindow.setContent(infowindowContent);
                    infowindow.open({
                        anchor:marker,
                        map,
                        //shouldFocus: true,
                    });
                })
                marker.addListener('mouseover',()=>{
                    if (infowindow.getContent().indexOf('infowindow--active') < 0) {
                        closeInfoWindow();
                        infowindow.setContent(infowindowContent);
                        infowindow.open({
                            anchor:marker,
                            map,
                            //shouldFocus: true,
                        });
                    }
                });
                marker.addListener('click',()=>{
                    openPin(e.id, true)
                })
                marker.addListener('mouseout',()=>{
                    if (infowindow.getContent().indexOf('infowindow--active') < 0) {
                        infowindowTimeout = setTimeout(closeInfoWindow, 250);
                    }
                })
                /*marker.addListener('blur',()=>{
                    infowindow.close();
                })*/
                bounds.extend({ lat: parseFloat(e.lat), lng: parseFloat(e.lng)});
               // marker.map = map;
                clusters.addMarker(marker, true);
                e.marker = marker;
            }
            if (addThisElement){
                fitBounds = true;
                //e.marker.setMap(map);
                clusters.addMarker(e.marker, true);
                bounds.extend({ lat: parseFloat(e.lat), lng: parseFloat(e.lng)});
                if(e.venueCard){
                    e.venueCard.classList.remove('map-venue-card__hidden');
                }
            }else{
                //e.marker.setMap(null);
                if(e.venueCard){
                    e.venueCard.classList.add('map-venue-card__hidden');
                }
            }
        });
        clusters.render();
    };
    //Geolocate
    let glat = 0;
    let glng = 0;
    //console.log('Geolocate Try')
    if (activeGeolocalisation && navigator.geolocation) {
        fitBounds = true;
        navigator.geolocation.getCurrentPosition(position => {
            glat = position.coords.latitude;
            glng = position.coords.longitude;
            let geolocateIconSvgCode = window.btoa(geolocateIconSvg);
            let marker = new google.maps.Marker({
                position:{ lat: glat, lng: glng},
                lat:glat,
                lng:glng,
                icon: {
                    url: `data:image/svg+xml;base64,${geolocateIconSvgCode}`,
                    //path:pinpath,
                    scaledSize: new google.maps.Size(geolocateIconWidth, geolocateIconHeight),
                    anchor: new google.maps.Point(geolocateAnchorX,geolocateAnchorY),
                },
                map: map,
                id:'geolocate-pin',
                optimized: false
            });
            bounds.extend({ lat: glat, lng: glng});
            marker.setMap(map);
            map.fitBounds(bounds);
        });
    }
    if (fitBounds) {
        map.fitBounds(bounds);
    }
}

const searchClear = document.getElementsByClassName('js-clear-search');
if(searchClear){
    searchClear[0].addEventListener('click',clearTextualSearch)
}

function clearTextualSearch(e){
    e.preventDefault();
    searchInput[0].value = '';
    searchInput[0].parentElement.classList.remove('map-text-search__has-data');
    document.getElementsByTagName('body')[0].classList.remove('map-venue-cards-open');
    redoMarkers();
    return false;
}

Array.prototype.forEach.call(mapVenueCatds,function(el){
    el.addEventListener('click',function(){
        openPin(el.getAttribute('data-id'));
    })
})

function findIndex(via,value){
    let toReturn = "";
    actMapData.forEach(function(e){
        if(e[via] == value){
            toReturn = e;
        }
    })
    return toReturn;
}

function openPin(id=0, animated=true){
    if($dataPanel != null){
        $dataPanel.destroy();
    }
    const elementToOpen = findIndex('id',id); 
    mapElement[0].setAttribute('data-open-pin',id);
    const dataPanel = document.getElementsByClassName('js-close-data-panel');

    if(map.getZoom() < 14){
        window.localStorage.setItem('gmap-center',map.getCenter());
        window.localStorage.setItem('gmap-zoom',map.getZoom());
    }

    //const dataPanel = document.getElementsByClassName('data-panel');
    if(dataPanel.length != 0){
        dataPanel[0].focus();
        dataPanel[0].blur();
    }


    const infowindowContent = generateInfoWindowContent(elementToOpen);

    if (map.getZoom() < zoomOnOpen) {
        map.setZoom(zoomOnOpen);
    }
    if (animated) {
        map.panTo(new google.maps.LatLng(elementToOpen.lat,elementToOpen.lng));
    } else {
        map.setCenter(new google.maps.LatLng(elementToOpen.lat,elementToOpen.lng));
    }
    closeInfoWindow();
    infowindow.setContent(infowindowContent.replace('"infowindow"', '"infowindow infowindow--active"'));
    infowindow.open({
        anchor:elementToOpen.marker,
        map,
        //shouldFocus: true,
    });
    //console.log(elementToOpen);
    const $panel = document.querySelector('.carte-layout__data-panel');
    if($panel){
        $panel.classList.remove('carte-layout__data-panel--hidden');
    }

    let $sliderHtml = '';
    //console.log(elementToOpen.images);
    if(elementToOpen.images){
        Array.prototype.forEach.call(elementToOpen.images,function(el){
            //console.log(el);
            $sliderHtml += '<img src="'+el+'" loading="lazy" alt="'+elementToOpen.title+'" /> ';
        })
    }
    document.querySelector('.data-panel__slider').innerHTML = $sliderHtml;

    let $badgesHtml = '';
    elementToOpen.categ.split('|').forEach((el)=>{
        if(el){
            $badgesHtml += '<span class="map-badge">'+el+'</span> ';
        }
    })
    if(document.querySelector('.data-panel__badges')){
        document.querySelector('.data-panel__badges').innerHTML = $badgesHtml;
    }

    const $defaultFill = document.getElementsByClassName('js-default-fill');
    Array.prototype.forEach.call($defaultFill,function(el){
        console.log(elementToOpen[el.getAttribute("data-filltype")]);
        if(elementToOpen[el.getAttribute("data-filltype")]){
            el.innerHTML = elementToOpen[el.getAttribute("data-filltype")];
            el.parentElement.setAttribute('style','');
        }else{
            el.parentElement.setAttribute('style','display:none;');
        }
    })

    const $emailFill = document.getElementsByClassName('js-email-fill');
    Array.prototype.forEach.call($emailFill,function(el){
        console.log(elementToOpen[el.getAttribute("data-filltype")]);
        if(elementToOpen[el.getAttribute("data-filltype")]){
            el.innerHTML = elementToOpen[el.getAttribute("data-filltype")];
            el.setAttribute('href','mailto:'+elementToOpen[el.getAttribute("data-filltype")])
            el.parentElement.setAttribute('style','');
        }else{
            el.parentElement.setAttribute('style','display:none;');
        }
    })

    if(document.querySelector('.data-panel__know-more')){
        if(elementToOpen.link == ''){
            document.querySelector('.data-panel__know-more').setAttribute('style','display:none;');
        }else{
            document.querySelector('.data-panel__know-more').setAttribute('href',elementToOpen.link);
            document.querySelector('.data-panel__know-more').setAttribute('style','');
        }
    }
    if(document.querySelector('.data-panel__gmaps')){
        document.querySelector('.data-panel__gmaps').setAttribute('href',"https://www.google.com/maps/search/"+elementToOpen.title+"/@"+elementToOpen.lat+","+elementToOpen.lng+",15z");
    }

    $dataPanel = tns({
        //mode: 'gallery',
        //animateIn: 'fadeInDown',
        //animateOut: 'fadeOutDown',
        animateDelay: 750,
        autoplayTimeout: 6000,
        controls: true,
        container: '.data-panel__slider',
        autoplay: true,
        //autoplayButton: false,
        nav: true,
    })
}

if(document.querySelector('.js-close-data-panel')){
    document.querySelector('.js-close-data-panel').addEventListener('click',closePin);
}

function closePin(resetPosition){
    if (resetPosition !== false) {
        resetPosition = true;
    }
    //mapElement[0].focus();
    //mapElement[0].blur();
    closeInfoWindow();
    const $panel = document.querySelector('.carte-layout__data-panel');
    if($panel && $panel.classList.contains('carte-layout__data-panel--hidden')){
        //already closed
        return;
    } else if ($panel) {
        $panel.classList.add('carte-layout__data-panel--hidden');
    }
    mapElement[0].setAttribute('data-open-pin','');
    // Attendre que l'anim fermeture soit finie pour ensuite réajuster la map.
    //console.log('hey')
    if (resetPosition) {
        if(window.localStorage.getItem('gmap-zoom')){
            //console.log(window.localStorage.getItem('gmap-zoom'));
            map.setZoom(parseFloat(window.localStorage.getItem('gmap-zoom')));
        }
        if(window.localStorage.getItem('gmap-center')){
            let center = window.localStorage.getItem('gmap-center').replace('(','').replace(')','').replace(' ','').split(',');
            //console.log(center)
            map.panTo(new google.maps.LatLng(center[0],center[1]));
        }
    }
    /*window.setTimeout(function(){
        map.fitBounds(bounds);
    },300)*/
}

const categSelectors = document.getElementsByClassName('js-select-category');
if(categSelectors){
    Array.prototype.forEach.call(categSelectors,function(el){
        el.addEventListener('click',function(e){
            e.preventDefault();
            let categ = el.getAttribute('data-categ');
            let optionIsInSelects = false;
            //Si on trouve la catégorie dans les selects du header
            const selects = document.getElementsByClassName('map-category-select');
            Array.prototype.forEach.call(selects,function(el){
                Array.prototype.forEach.call(el.options,function(option){
                    //Essai de trouver la catégorie parmis les selects
                    if(option.value == categ){
                        //console.log(el.value);
                        let ogValue = el.value;    
                        if(el.value.includes(categ)){
                            ogValue.splice(ogValue.indexOf(categ));
                        }else{
                            ogValue.push(categ)
                        }
                        el.setValue(ogValue);
                        optionIsInSelects = true;
                    }
                })
            })
            if(!optionIsInSelects){
                //Set/unset de la catégorie si elle n'est pas dans les selects
                if(document.getElementsByTagName('body')[0].getAttribute('data-additionnal-categ') == categ){
                    document.getElementsByTagName('body')[0].setAttribute('data-additionnal-categ','');
                }else{
                    document.getElementsByTagName('body')[0].setAttribute('data-additionnal-categ',categ);
                }
                redoMarkers();
            }
            return false;
        })
    });
}

window.addEventListener('keydown',checkForEscape);

function checkForEscape(e){
    //console.log(e.keyCode);
    if(e.keyCode == 27){
        closePin();
    }
}